import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/copy.svg'
import _imports_1 from '@/assets/img/icon/delete.svg'
import _imports_2 from '@/assets/img/grid-skel.png'


const _hoisted_1 = { class: "active-price-detail" }
const _hoisted_2 = { class: "flex justify-between items-center mb-3" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "flex w-full mb-2" }
const _hoisted_6 = { class: "w-full md:w-3/4" }
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 md:w-1/6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Belaku Mulai")
], -1)
const _hoisted_9 = { class: "w-4/6 md:w-5/6" }
const _hoisted_10 = { class: "font-bold text-subtitle1" }
const _hoisted_11 = { class: "flex w-full mb-2" }
const _hoisted_12 = { class: "w-full md:w-3/4" }
const _hoisted_13 = { class: "flex w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 md:w-1/6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Perubahan Harga")
], -1)
const _hoisted_15 = { class: "w-4/6 md:w-5/6" }
const _hoisted_16 = { class: "font-bold color-primary" }
const _hoisted_17 = { class: "md:flex w-full" }
const _hoisted_18 = { class: "w-full md:w-3/4" }
const _hoisted_19 = { class: "flex w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/6 md:w-1/6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Jenis Penumpang")
], -1)
const _hoisted_21 = { class: "w-4/6 md:w-5/6" }
const _hoisted_22 = { class: "font-bold text-subtitle1" }
const _hoisted_23 = { class: "w-full mt-3 md:mt-0 md:w-1/4" }
const _hoisted_24 = { class: "flex w-full md:justify-end" }
const _hoisted_25 = { class: "color-blue-grey-lighten-1" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Versi Revisi ")
const _hoisted_27 = { class: "text-black" }
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "Perubahan Harga", -1)
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Perubahan'), -1)
const _hoisted_32 = { class: "my-3" }
const _hoisted_33 = { class: "flex items-center price-chip" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  class: "hidden",
  id: "table-view"
}
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "lg:flex items-center lg:justify-between excel-header" }
const _hoisted_39 = { class: "w-full lg:w-2/3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "Jenis Penumpang", -1)
const _hoisted_41 = { class: "flex items-center price-chip mt-3" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "w-full mt-3 lg:mt-0 lg:w-1/3" }
const _hoisted_45 = { class: "flex lg:justify-end" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-2 w-4 h-4",
  alt: "copy"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal color-blue-grey-darken-1" }, "Duplikat", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-2 w-4 h-4",
  alt: "del"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "font-normal text-red" }, "Hapus", -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold color-blue-grey-lighten-3" }, "Simpan Tabel", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "xxx",
    class: "excel-clone"
  })
], -1)
const _hoisted_55 = { class: "flex" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString('Tambah Asal & Tujuan'))
const _hoisted_58 = {
  class: "",
  id: "default-view"
}
const _hoisted_59 = { class: "w-full flex justify-center" }
const _hoisted_60 = { class: "mt-5 mb-5" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mb-2"
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-center text-grey" }, "Tambahkan tabel harga sesuai jenis penumpang", -1)
const _hoisted_63 = { class: "flex items-center justify-center mt-7" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah jenis penumpang'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TypePassengerForm = _resolveComponent("TypePassengerForm")!
  const _component_PriceAdjustmentForm = _resolveComponent("PriceAdjustmentForm")!
  const _component_OriginDestinationForm = _resolveComponent("OriginDestinationForm")!
  const _component_ActivePriceForm = _resolveComponent("ActivePriceForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "card-item-category mb-4 px-3"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.dataPrice.Name), 1),
              _createElementVNode("i", {
                class: "pi pi-ellipsis-h text-2xl cursor-pointer text-black",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropDown($event, _ctx.dataPrice))),
                "aria:haspopup": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.moment(_ctx.dataPrice.PeriodStart).locale('id').format('DD MMMM YYYY')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.dataPrice.LastActiveChanges), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.dataPrice.PassengerType), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("b", _hoisted_27, _toDisplayString(_ctx.dataPrice.Version), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", null, [
            (_ctx.titleButton !== '')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "flex gap-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAdjustmentForm(_ctx.dataPrice)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.iconButton ? _ctx.iconButton : _ctx.$icon.svg.plusEva
                    }, null, 8, _hoisted_30),
                    _hoisted_31
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceChange, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(item.Id === _ctx.priceChangeId ? 'flex items-center rounded px-3 py-0.5 mr-4 cursor-pointer active' : 'flex items-center rounded px-3 py-0.5 mr-4 cursor-pointer inactive')
                }, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.changeSelectedPriceChange(item.Id))
                  }, _toDisplayString(item.Name), 9, _hoisted_34),
                  _createElementVNode("div", {
                    class: _normalizeClass(item.IsActive ? 'p-1.5 rounded ml-2 color-box active' : 'p-1.5 rounded ml-2 color-box inactive'),
                    onClick: ($event: any) => (_ctx.activatePriceChange(item.Id))
                  }, null, 10, _hoisted_35)
                ], 2)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricePassenger, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(item.IdPassenger === _ctx.pricePassengerId ? 'flex items-center rounded px-3 py-0.5 mr-4 active cursor-pointer' : 'flex items-center rounded px-3 py-0.5 mr-4 inactive cursor-pointer'),
                        onClick: ($event: any) => (_ctx.changeSelectedPassengerChange(item.IdPassenger))
                      }, _toDisplayString(item.PassengerName), 11, _hoisted_42)
                    ]))
                  }), 128)),
                  _createVNode(_component_Button, {
                    class: "btn-add-small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showForm(_ctx.dataPrice)))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _ctx.$icon.svg.plusEva
                      }, null, 8, _hoisted_43)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", {
                    class: "flex items-center mr-4 cursor-pointer",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showForm(_ctx.dataPrice, 3)))
                  }, _hoisted_48),
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer mr-4",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteCategory()))
                  }, _hoisted_51),
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitDataExcel()))
                  }, _hoisted_53)
                ])
              ])
            ]),
            _hoisted_54,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", {
                  class: "flex items-center text-primary font-bold cursor-pointer",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOriginDestinationForm(_ctx.dataPrice)))
                }, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$icon.svg.plusBlueEva,
                    class: "mr-2"
                  }, null, 8, _hoisted_56),
                  _hoisted_57
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_Button, {
                  class: "flex gap-2 extra-submit-button text-primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showForm(_ctx.dataPrice, 0))),
                  outlined: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$icon.svg.plusBlueEva
                    }, null, 8, _hoisted_64),
                    _hoisted_65
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListActions, {
          edit: true,
          del: true,
          editTitle: "Edit Harga",
          delTitle: "Hapus harga",
          onDel: _ctx.onDelete,
          onEdit: _ctx.onEdit
        }, null, 8, ["onDel", "onEdit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      onHideDialog: _ctx.hideModalForm,
      confirmDialogDelete: _ctx.hideModalForm,
      onOnDelete: _ctx.hideModalForm,
      canDelete: false
    }, {
      form: _withCtx(() => [
        (_ctx.formSwitch === 0 || _ctx.formSwitch === 3)
          ? (_openBlock(), _createBlock(_component_TypePassengerForm, {
              key: 0,
              type: _ctx.formSwitch
            }, null, 8, ["type"]))
          : (_ctx.formSwitch === 1)
            ? (_openBlock(), _createBlock(_component_PriceAdjustmentForm, { key: 1 }))
            : (_ctx.formSwitch === 2)
              ? (_openBlock(), _createBlock(_component_OriginDestinationForm, {
                  key: 2,
                  originList: _ctx.originList
                }, null, 8, ["originList"]))
              : (_ctx.formSwitch === 4)
                ? (_openBlock(), _createBlock(_component_ActivePriceForm, { key: 3 }))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "onHideDialog", "confirmDialogDelete", "onOnDelete"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      title: _ctx.attrModalConfirmation.title,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onOnSubmit: _ctx.processSubmitModal,
      onHideDialog: _ctx.hideConfirmModal
    }, null, 8, ["show", "title", "imgContent", "subTitle", "btnSubmitTitle", "onOnSubmit", "onHideDialog"])
  ]))
}